import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Column } from '../pages/Components/Table/Types';
import { ContasReceberLancamento } from '../routes/RoutesNames';
import ContaReceberController from '../controllers/ContaReceberController';
import BoletoController from '../controllers/BoletoController';
import { ButtonMenu } from '../shared/components/ButtonMenu';
import { formatDate } from '../shared/utils/helpers/date';
import { formatCurrency } from '../shared/utils/helpers/numbers';
import { formatarData } from '../shared/utils/helpers/date';
import { Dashboard } from '../shared/types/ContasReceber';
import Status from '../pages/Components/Status/Index';
import { openBase64InNewTab, downloadBase64 } from '../shared/utils/helpers/base64';
import * as path from '../routes/RoutesNames';
import { toast } from 'react-toastify';
import Api from '../services/Api';
// A mesma lista que a aba Finalidade do Pedido usa. Reaproveitada de proposito: se
// aparecer uma finalidade nova, os dois lugares passam a oferecer sozinhos.
import { OPTIONS_FINALITY } from '../shared/utils/const/FinalityOptions';

const initialValues = {
  status: 'Todos',
  statusBoleto: 'Todos',
  descricao: '',
  cliente_nome: '',
  vnd_id: '',                 // filtro por pedido (venda)
  numerotitulocobranca: '',   // filtro por nosso-numero do boleto
  valor: 0,
  observacao: '',
  vencimento: formatarData(new Date((new Date()).setMonth(new Date().getMonth() - 1))),
  vencimentoFinal: formatarData(new Date()),
}

const STATUS = [
  { value: 'Todos', label: 'Todos' },
  { value: 'Em Aberto', label: 'Em Aberto' },
  // A proc calcula e o grid exibe VENCIDO, mas nao havia como filtrar por ele.
  { value: 'Vencido', label: 'Vencido' },
  { value: 'Pago', label: 'Pago' },
  { value: 'Cancelado', label: 'Cancelado' }
]

const STATUS_BOLETO = [
  { value: 'Todos', label: 'Todos' },
  { value: 'Gerados', label: 'Gerados' },
  { value: 'Não Gerados', label: 'Não Gerados' }
]

/*
  Pago - Verde
  Em aberto - Azul
  Atrasado - Vermelho
  Cancelado - Cinza
*/
const getStatusColor = (s: string) => ({
  'finalizado': '#4caf50',
  'pago': '#4caf50',
  'em aberto': '#42a5f5',
  'cancelado': '#999',
  'a criar': '#ef5350'
})[s.toLowerCase()] || '#999'

const getBoletoStatusColor = (s: string) => ({
  'boleto registrado': '#42a5f5'
})[s.toLowerCase()] || '#ef5350'

// O recibo só existe para locação. Concentrado aqui para o botão, o item de menu e a
// validação usarem o MESMO teste - regra de finalidade espalhada foi o que fez o CFOP
// e o frete divergirem entre tela e proc neste sistema.
const ehLocacao = (valor?: string) => !!valor && valor.toLowerCase().includes('oca');

// [AJUSTE 20/08/2026] A exigência de status Pago FOI REMOVIDA a pedido do cliente: o recibo
// e a 2ª via passam a ser emitidos independentemente do status da conta.
//
// O motivo é factual: `PAGO` não existia em nenhuma das 341 parcelas de produção. Ele só é
// gravado pelo lançamento no Caixa e pela venda à vista, e nenhum dos dois é usado - exigir
// Pago deixaria a funcionalidade sem uma única conta elegível. O script 68, que levava essa
// regra ao servidor, foi APOSENTADO sem nunca ter sido aplicado.
//
// Sobra UMA guarda de status, e ela não é sobre pagamento: parcela CANCELADA não recebe
// recibo, porque "recebemos a importância de R$ X" para uma parcela cancelada é documento
// falso. Isso vive no servidor (script 69, aplicado nos dois ambientes em 20/08) e aqui só
// como aviso na tela - o servidor é quem manda.
const ehCancelado = (status?: string) => (status ?? '').trim().toUpperCase() === 'CANCELADO';

// Espelha o MaxParcelasPorLote do RelatorioRepository. Duplicado por necessidade (não há
// contrato compartilhado entre front e back aqui); o servidor é quem manda - esta cópia
// só evita a espera inútil. Se um dia mudar, mudam os dois.
//
// 25 e não 50: medido em 14/08, cada PDF leva ~8s, e 50 (10 ondas de 5 em paralelo)
// passaria dos 60s do nginx. A conta está no comentário do RelatorioRepository.
const MAX_PARCELAS_POR_LOTE = 25;

const useContasReceberPesquisar = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dropdownValueStatus, setDropdownValueStatus] = React.useState('Todos');
  const [dropdownValueStatusBoleto, setDropdownValueStatusBoleto] = React.useState('Todos');
  const [dropdownValueFinalidade, setDropdownValueFinalidade] = React.useState('Todos');
  // Os cre_id de locação que a busca atual trouxe. É o que o lote envia: o cliente
  // pediu "somente as que popularem o datagrid".
  const [idsLocacaoNaTela, setIdsLocacaoNaTela] = React.useState<number[]>([]);
  // [AJUSTE 14/08] Locação com valor zerado NÃO gera recibo (recibo de R$ 0,00 é
  // constrangedor e queimaria número). O backend já recusava, mas em silêncio: o usuário
  // via 6 linhas e 4 recibos e não sabia por quê. Contadas aqui para o aviso ser dado
  // ANTES e DEPOIS de gerar - a autoridade continua sendo a proc.
  const [qtdZeradasNaTela, setQtdZeradasNaTela] = React.useState<number>(0);
  const [loadingRecibos, setLoadingRecibos] = React.useState(false);
  const [statisticValues, setStatisticValues] = React.useState<Dashboard>({
    TotalPago: 0,
    TotalReceber: 0
  });

  const handleOpenEditarParcelaModal = (item: any) => {
    const itemFormatado = {
      cre_id: item.codigo, // O modal espera cre_id, mas a tabela tem codigo
      dataVencimento: item.cre_vencimento, // O modal espera dataVencimento
      boletoGerado: item.boletoGerado !== 'N'
    };

    setSelectedParcela(itemFormatado);
    setModalEditarParcelaOpen(true);
  };
  const handleCloseEditarParcelaModal = () => {
    setSelectedParcela(null); // Limpa ao fechar
    setModalEditarParcelaOpen(false);
  };


  const [selectedParcela, setSelectedParcela] = useState<any>(null);
  const [modalEditarParcelaOpen, setModalEditarParcelaOpen] = useState(false);

  const tableColumns: Column[] = [
    { id: '', label: '', width: 10, minWidth: 0, maxWidth: undefined },
    { id: 'codigo', label: 'Código', minWidth: 0, hidden: false, align: 'center', maxWidth: undefined },
    { id: 'cre_status', label: 'Status', minWidth: 0, maxWidth: undefined },
    { id: 'statusBoleto', label: 'Status Boleto', minWidth: 0, maxWidth: undefined },
    // A proc devolve o pedido como "pedido" (CONTASRECEBER.vnd_id); antes a coluna
    // lia cre_numerotitulocobranca, que nao vem no result set, e ficava sempre vazia.
    { id: 'pedido', label: 'Pedido', minWidth: 0, maxWidth: undefined },
    { id: 'cre_vencimento', label: 'Vencimento', minWidth: 0, maxWidth: undefined },
    { id: 'cli_nome', label: 'Cliente', minWidth: 0, maxWidth: undefined },
    { id: 'cre_valor', label: 'Valor Pre', minWidth: 0, maxWidth: undefined },
    // { id: 'Saldo', label: 'Saldo', minWidth: 0, maxWidth: undefined },
    { id: 'cre_observacao', label: 'parcela', minWidth: 0, maxWidth: undefined },
    { id: 'cre_descricao', label: 'Descrição', minWidth: 0, maxWidth: undefined },
    // [NOVO 12/08] O número do recibo na tela evita a pergunta "esta parcela já teve
    // recibo?" - a resposta fica visível sem abrir nada, e é ela que diz se o item de
    // menu "2ª via" aparece habilitado.
    { id: 'reciboNumero', label: 'Recibo', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'codigoParcela', label: 'Código + Parcela', minWidth: 0, hidden: true, maxWidth: undefined },
    { id: 'BtnMenu', label: 'Ações', width: 80, minWidth: 0, maxWidth: undefined },
  ];

  const [tableRows, setTableRows] = useState([]);

  const handleChangeDropdownStatus = (event: any) => {
    setDropdownValueStatus(event.target.value);
  };

  const handleChangeDropdownStatusBoleto = (event: any) => {
    setDropdownValueStatusBoleto(event.target.value);
  };

  const handleChangeDropdownFinalidade = (event: any) => {
    setDropdownValueFinalidade(event.target.value);
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(path.ContasReceberCadastrar);
  };

  const handlePrint = async (): Promise<void> => {
    //
  }

  /**
   * Salva o arquivo que o servidor devolveu, com o nome e o tipo que ELE informou.
   *
   * [CORRIGIDO 21/08/2026] Antes a tela fixava `.zip` e montava o nome com
   * `item.codigo` - o id da PARCELA. Dois problemas: um recibo so vinha compactado (o
   * cliente reclamou de ter de descompactar para ver uma folha), e o arquivo se chamava
   * "Recibo-472" quando o recibo era o 2531/2026. Agora um recibo vem PDF, varios vem
   * .zip, e quem decide e o servidor - que e onde o numero do recibo existe.
   *
   * Fica no escopo do hook, e nao dentro do handleSubmit como os outros handlers: o
   * download do LOTE acontece fora dali, e os tres caminhos de recibo tem de usar a
   * mesma funcao - senao um deles volta a fixar .zip no dia em que alguem mexer.
   *
   * O fallback cobre a janela em que a API ainda for a antiga: sem `nomeArquivo` o
   * comportamento volta a ser o de antes, em vez de baixar arquivo sem nome.
   */
  const baixarRecibo = (d: any, nomeReserva = 'Recibo') => {
    // [CORRIGIDO 16/09/2026] O fallback assumia .zip quando o servidor nao mandava o
    // nome. Em producao o servidor mandou um PDF e o campo nao chegou: o arquivo foi
    // salvo como .zip e o Windows respondeu "a pasta compactada esta vazia" - que e o
    // que ele diz quando o arquivo nao e um zip.
    //
    // Por que nao depender mais do campo: o CONTEUDO ja diz o que e. Todo PDF comeca
    // com "%PDF", que em base64 e sempre "JVBERi0". Ler isso e mais confiavel que
    // qualquer combinacao de servidor novo com tela antiga, e cobre tambem o caminho
    // contrario - um zip salvo como .pdf.
    const ehPdf = typeof d?.base64 === 'string' && d.base64.startsWith('JVBERi0');
    const extensao = ehPdf ? 'pdf' : 'zip';

    // O nome do servidor continua tendo precedencia: e la que o NUMERO do recibo existe
    // (2531/2026) e a tela so conhece o id da parcela. So a extensao dele e corrigida,
    // se contradisser o conteudo.
    const nomeServidor = typeof d?.nomeArquivo === 'string' ? d.nomeArquivo.trim() : '';
    const nomeBase = (nomeServidor || nomeReserva).replace(/\.(pdf|zip)$/i, '');

    // Barra em nome de arquivo o navegador trunca: "Recibo-2531/2026.pdf" viraria
    // "2026.pdf". O numero do recibo tem barra, entao ela vira hifen.
    const nome = nomeBase.replace(/[/:*?"<>|]/g, '-') + '.' + extensao;
    const tipo = ehPdf ? 'application/pdf' : 'application/zip';

    downloadBase64(d.base64, nome, tipo);
  };

  const handleSubmit = async (values: any) => {
    setLoading(true);
    const dataRows: any = [];

    const result = await ContaReceberController.Listar({
      ...values,
      status: dropdownValueStatus,
      statusBoleto: dropdownValueStatusBoleto,
      finalidade: dropdownValueFinalidade
    });

    // O Dashboard recebe os MESMOS filtros da lista (script 51d alinhou o WHERE das
    // duas procs). Antes ele nem tinha o parametro de finalidade, e os totais do topo
    // contradiziam o grid - o mesmo desencontro que os scripts 42/43 corrigiram no
    // relatorio. O bloco [3] do 51d e o teste que impede isso de voltar.
    const dashboard = await ContaReceberController.Dashboard({
      ...values,
      status: dropdownValueStatus,
      statusBoleto: dropdownValueStatusBoleto,
      finalidade: dropdownValueFinalidade
    });

    const handleReceberItem = (item: any) => {
      navigate(ContasReceberLancamento.replace(':id', item.codigo), { state: { duploClick: true, codigoParcela: item.codigoParcela, valorParcela: item.cre_valor } });
    };

    // 2a via de UM recibo, com o numero original. So aparece habilitada quando a
    // parcela JA tem recibo: reimprimir algo que nunca foi emitido seria emissao
    // disfarcada, sem passar pelo controle de numeracao.
    const handleSegundaViaRecibo = async (item: any) => {
      setLoadingRecibos(true);
      try {
        const res = await Api.post('api/relatorio/ReciboSegundaVia', { CreId: Number(item.codigo) });
        if (res?.data?.base64) {
          baixarRecibo(res.data);
          return;
        }
        toast('Não foi possível gerar a 2ª via.', { type: 'error' });
      } catch (e: any) {
        const d = e?.response?.data;
        toast(d?.ErroDetalhado || d?.Erro || 'Não foi possível gerar a 2ª via do recibo.',
              { type: 'error', autoClose: 8000 });
      } finally {
        setLoadingRecibos(false);
      }
    };

    // [NOVO 19/08/2026] Emite o recibo de UMA parcela. Reaproveita o endpoint do lote com
    // uma lista de um elemento: é a mesma proc, a mesma numeração e as mesmas guardas -
    // um caminho paralelo só para "um" seria uma segunda regra, livre para divergir da
    // primeira.
    const handleGerarReciboIndividual = async (item: any) => {
      setLoadingRecibos(true);
      try {
        const res = await Api.post('api/relatorio/RecibosLocacaoLote',
                                   { CreIds: [Number(item.codigo)] });
        const d = res?.data;

        if (!d?.base64) {
          toast('Nenhum recibo foi gerado.', { type: 'error' });
          return;
        }

        baixarRecibo(d, `Recibo-${item.codigo}`);

        // "Reimpresso" aqui não é falha: a numeração é idempotente, então clicar de novo
        // devolve o MESMO documento. Dizer qual dos dois aconteceu evita a dúvida de ter
        // gerado um segundo recibo sem querer.
        toast(d.novos > 0 ? 'Recibo emitido.' : 'Recibo reimpresso com o número original.',
              { type: 'success' });

        // Recarrega para a coluna Recibo aparecer preenchida - e o menu passar a oferecer
        // a 2ª via em vez do Gerar.
        await handleSubmit(formRef?.current?.values ?? initialValues);
      } catch (e: any) {
        const d = e?.response?.data;
        toast(d?.ErroDetalhado || d?.Erro || 'Não foi possível gerar o recibo.',
              { type: 'error', autoClose: 10000 });
      } finally {
        setLoadingRecibos(false);
      }
    };

    // [SICOOB 30/09/2026] A acao passou a atender os dois bancos, e eles entregam a 2a via
    // de formas diferentes: o Banco do Brasil devolve uma URL que ele mesmo resolve, o
    // Sicoob devolve o PDF em base64 e nao tem link nenhum. Por isso os dois ramos - a API
    // preenche UrlImagemBoleto OU PdfBase64, nunca os dois.
    //
    // O ramo do BB e o de sempre, byte a byte. O que faltava era o resto: antes, clique
    // sem link nao fazia absolutamente nada, sem aviso nenhum - foi assim que boleto do
    // Sicoob ficou "sem resposta" na tela.
    const handlePrintItem = async (item: any) => {
      const res = await BoletoController.Detalhar({
        creId: item.codigo
      })

      const link = res.Data?.UrlImagemBoleto
      if (link) {
        window.open(link, "_blank");
        return;
      }

      const pdf = res.Data?.PdfBase64
      if (pdf) {
        // openBase64InNewTab acrescenta a extensao sozinho no caminho de download
        // (quando o navegador bloqueia a aba), entao o .pdf do nome sai aqui.
        const nome = (res.Data?.NomeArquivo || `boleto-${item.codigo}.pdf`).replace(/\.pdf$/i, '');
        openBase64InNewTab(pdf, nome, 'application/pdf');
        return;
      }

      toast(
        res.ErroDetalhado || 'Nao foi possivel obter a segunda via deste boleto.',
        { type: 'error', autoClose: 8000 }
      )
    };

    // [AJUSTE 11/08/2026] A confirmacao saiu daqui (era um confirm() do navegador)
    // e passou para o campo `confirmar` do item do menu, que usa o mesmo dialogo de
    // todas as outras acoes destrutivas. O confirm() nativo bloqueia a thread, nao
    // aceita estilo e em vários navegadores oferece "nao mostrar mais" - o usuario
    // marca uma vez e a protecao desaparece.
    const handleBaixaBoletoItem = async (item: any) => {
      const res = await BoletoController.Cancelar({
        creId: item.codigo
      })
      if (res.StatusCode && res.StatusCode >= 200 && res.StatusCode < 300) {
        setTableRows((t: any) => t.map((o: any) => ({ ...o, "statusBoleto": o.codigo === item.codigo ? <Status text={"BOLETO CANCELADO"} color={getBoletoStatusColor('')} /> : o.statusBoleto}) ))
        toast('Boleto cancelado no banco.', { type: 'success' })
        return
      }
      // [AJUSTE 11/08/2026] Nao havia ramo de falha: o clique falhava e a tela nao dizia
      // nada. O ErroDetalhado traz o texto do proprio BB (ex.: boleto ja baixado).
      toast(
        res.ErroDetalhado || 'Nao foi possivel cancelar o boleto. Tente novamente ou verifique o boleto no banco.',
        { type: 'error', autoClose: 8000 }
      )
    }

    if (dashboard.StatusCode === 200) {
      setStatisticValues({
        TotalReceber: dashboard.Data.total_receber,
        TotalPago: dashboard.Data.total_pago,
      })
    }


    if (result.StatusCode === 200) {
      result.Data.map((item: any) => {
        dataRows.push({
          ...item,
          vencimentoOriginal: item.cre_vencimento, 

          //cre_vencimento: formatDate(item.cre_vencimento),
          cre_status: item?.cre_status && (
            <Status text={item?.cre_status || ''} color={getStatusColor(item?.cre_status || '')} />
          ),
          statusBoleto: item?.statusBoleto && (
            <Status text={item?.statusBoleto || ''} color={getBoletoStatusColor(item?.statusBoleto || '')} />
          ),
          BtnMenu: (
            <ButtonMenu
              items={[
                {
                  onClick: () => { handleOpenEditarParcelaModal(item) },
                  menu: 'Editar',
                },
                {
                  onClick: () => { handleReceberItem(item) },
                  menu: 'Quitar',
                },
                ...( item.boletoGerado !== 'N' ? [
                    {
                      onClick: () => { handlePrintItem(item) },
                      menu: 'Segunda Via (Boleto)',
                    },
                  ] : []
                ),
                ...( item.boletoGerado !== 'N' && item.cre_status?.toLowerCase() === 'em aberto' ? [
                    {
                      onClick: () => { handleBaixaBoletoItem(item) },
                      menu: 'Cancelar (Boleto)',
                      confirmar: 'Cancelar e dar baixa neste boleto? O titulo deixa de valer no banco e nao ha segunda via a emitir.',
                      tituloConfirmar: 'Confirmar baixa do boleto',
                      // "Excluir" era o rotulo herdado, e nao e o que acontece: o boleto e
                      // baixado no banco. "Cancelar" tambem nao serve, porque e o rotulo do
                      // botao que DESISTE - dois "Cancelar" lado a lado no mesmo dialogo.
                      rotuloConfirmar: 'Dar baixa',
                    }
                  ] : []
                ),
                // [AJUSTE 20/08/2026] UM item de recibo por linha, e ele nunca desaparece
                // em parcela de locação - opção que some sem explicação já gerou chamado
                // neste sistema. Os três estados:
                //
                //   já tem recibo   -> 2ª Via, habilitada (inclusive se depois foi cancelada:
                //                      o documento existe e o número já foi gasto)
                //   está Cancelada  -> desabilitado, com o motivo NO RÓTULO
                //   qualquer outro  -> Gerar Recibo, habilitado
                //
                // O status de PAGAMENTO saiu da conta em 20/08, a pedido do cliente. O que
                // sobrou é a guarda de documento falso, não de pagamento.
                //
                // O motivo vai no rótulo porque o ButtonMenu não tem tooltip: em 18/08 um
                // botão que só explicava no hover virou "parou de funcionar".
                //
                // O Gerar pede confirmação: a numeração é idempotente para a MESMA parcela,
                // então repetir é inofensivo - mas clicar na LINHA ERRADA queima um número
                // que não volta, e as duas linhas ficam coladas no mesmo dropdown.
                ...( ehLocacao(item.finalidade)
                     ? [ item.reciboNumero
                         ? {
                             onClick: () => { handleSegundaViaRecibo(item) },
                             menu: '2ª Via (Recibo)',
                           }
                         : ehCancelado(item.cre_status)
                           ? {
                               menu: 'Gerar Recibo (parcela está Cancelada)',
                               disabled: true,
                             }
                           : {
                               onClick: () => { handleGerarReciboIndividual(item) },
                               menu: 'Gerar Recibo',
                               confirmar: 'Emitir o recibo desta parcela? O número é consumido e não volta atrás.',
                               // [CORRECAO 21/08/2026] Sem estes tres, o diálogo saía como
                               // "CONFIRMAR EXCLUSÃO" com botão vermelho "EXCLUIR" para uma
                               // EMISSÃO — herdado do padrão do componente, que foi escrito
                               // para exclusão. Virou chamado em produção, com razão.
                               tituloConfirmar: 'Confirmar emissão do recibo',
                               rotuloConfirmar: 'Emitir recibo',
                               destrutivo: false,
                             }
                       ]
                     : []
                )
              ]}
            />
          ),
          cre_vencimento: formatDate(item.cre_vencimento),
          cre_valor: formatCurrency(item.cre_valor, 2),
          codigo: item.codigo,
          codigoParcela: item.codigoParcela
        })
      })
      setTableRows(dataRows)

      // Guarda os ids de locação desta busca. Só eles vão ao lote - e a lista é
      // recalculada a cada pesquisa, então o botão sempre reflete o que está na tela.
      // O cre_valor aqui é o CRU (a formatação em R$ acontece na linha do grid).
      const locacoes = (result.Data || []).filter((i: any) => ehLocacao(i.finalidade));
      const comValor = locacoes.filter((i: any) => Number(i.cre_valor) > 0);

      setIdsLocacaoNaTela(
        comValor.map((i: any) => Number(i.codigo)).filter((n: number) => n > 0)
      );
      setQtdZeradasNaTela(locacoes.length - comValor.length);
    } else {
      setTableRows([])
      setIdsLocacaoNaTela([])
      setQtdZeradasNaTela(0)
    }

    setLoading(false);
  };

  // [NOVO 12/08] Gera os recibos das parcelas de locação que a busca trouxe.
  //
  // Exige o filtro de finalidade em Locação, como o cliente pediu. A checagem é do lado
  // de cá só para dar mensagem imediata - a proc valida de novo no servidor, porque
  // botão desabilitado é conveniência e não controle.
  const gerarRecibosLote = async () => {
    if (!ehLocacao(dropdownValueFinalidade)) {
      toast('Para gerar recibos, filtre a Finalidade em "Locação".', { type: 'warning' });
      return;
    }

    if (idsLocacaoNaTela.length === 0) {
      toast('Nenhuma parcela de locação na busca atual. Ajuste o período e pesquise de novo.',
            { type: 'warning', autoClose: 8000 });
      return;
    }

    // Teto acordado com o cliente. Avisar aqui poupa a ida ao servidor e, principalmente,
    // a espera: o servidor recusaria igual, mas só depois de o usuário aguardar.
    if (idsLocacaoNaTela.length > MAX_PARCELAS_POR_LOTE) {
      toast(`A busca trouxe ${idsLocacaoNaTela.length} parcelas de locação e o limite por lote é ${MAX_PARCELAS_POR_LOTE}. `
            + 'Reduza o período (um mês por vez, por exemplo) e gere em partes.',
            { type: 'warning', autoClose: 12000 });
      return;
    }

    setLoadingRecibos(true);
    try {
      const res = await Api.post('api/relatorio/RecibosLocacaoLote', { CreIds: idsLocacaoNaTela });
      const d = res?.data;

      if (!d?.base64) {
        toast('Nenhum recibo foi gerado.', { type: 'error' });
        return;
      }

      baixarRecibo(d, `Recibos-Locacao-${new Date().toISOString().slice(0, 10)}`);

      // Dizer o que aconteceu importa: com numeração idempotente, "reimpresso" é
      // resultado esperado, não falha - e sem essa frase o usuário não sabe se o
      // segundo clique gerou documento novo. E as puladas TÊM de ser mencionadas:
      // 6 linhas na tela e 4 recibos no zip, sem explicação, virou pergunta em 14/08.
      const pulou = qtdZeradasNaTela > 0
        ? ` ${qtdZeradasNaTela} parcela(s) não geraram recibo por estarem com valor R$ 0,00.`
        : '';

      toast(`${d.total} recibo(s): ${d.novos} emitido(s), ${d.reimpressos} reimpresso(s).${pulou}`,
            { type: 'success', autoClose: 12000 });

      await handleSubmit(formRef?.current?.values ?? initialValues);
    } catch (e: any) {
      const d = e?.response?.data;
      toast(d?.ErroDetalhado || d?.Erro || 'Não foi possível gerar os recibos.',
            { type: 'error', autoClose: 10000 });
    } finally {
      setLoadingRecibos(false);
    }
  };

  const downloadRelatorio = async () => {
    const v = formRef?.current?.values;
    try {
      setLoadingRelatorio(true);
      const response = await Api.post(`api/relatorio/ContasReceber`, { dataInicio: v.vencimento, dataFim: v.vencimentoFinal, status: dropdownValueStatus});
      openBase64InNewTab(response.data.base64, "my-file", "application/pdf");
      setLoadingRelatorio(false);
    }
    catch (e) {
      console.error(e)
      toast('Erro ao baixar relatório', { type: 'error' });
      setLoadingRelatorio(false);
    }
  }

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  const formRef = useRef(null);
  const [loadingRelatorio, setLoadingRelatorio] = useState(false);

  return {
    loading,
    tableColumns,
    tableRows,
    handleNavigation,
    handleChangeDropdownStatus,
    handleChangeDropdownStatusBoleto,
    handleChangeDropdownFinalidade,
    handlePrint,
    statisticValues,
    dropdownValueStatus,
    dropdownValueStatusBoleto,
    dropdownValueFinalidade,
    handleSubmit,
    initialValues,
    STATUS,
    STATUS_BOLETO,
    OPTIONS_FINALITY,
    // recibo
    gerarRecibosLote,
    loadingRecibos,
    // O botao so faz sentido com o filtro em Locacao E com parcela na tela.
    podeGerarRecibos: ehLocacao(dropdownValueFinalidade) && idsLocacaoNaTela.length > 0,
    qtdRecibosNaTela: idsLocacaoNaTela.length,
    qtdZeradasNaTela,
    modalEditarParcelaOpen,
    handleOpenEditarParcelaModal,
    handleCloseEditarParcelaModal,
    selectedParcela,
    formRef,
    downloadRelatorio,
    loadingRelatorio
  }
}

export default useContasReceberPesquisar;